import React from "react"
import {
  Heading as HeadingChakra,
  HeadingProps as HeadingChakraProps,
} from "@chakra-ui/react"
import { motion, HTMLMotionProps } from "framer-motion"

export type HeadingType = "large" | "medium" | "small"

type FramerMotionProps =
  | HTMLMotionProps<"h1">
  | HTMLMotionProps<"h2">
  | HTMLMotionProps<"h3">

type CustomHeadingProps = {
  /**
   * defines the styles to be displayed
   */
  type: HeadingType
}

export type HeadingProps = CustomHeadingProps &
  HeadingChakraProps &
  FramerMotionProps

const ChakraHeadingWithMotion = motion(HeadingChakra)

export const Heading: React.FC<HeadingProps> = ({
  children,
  type,
  color,
  ...props
}) => {
  switch (type) {
    case "large":
      return (
        <ChakraHeadingWithMotion
          lineHeight="heading"
          mt={0}
          as="h1"
          color={color}
          fontSize={{
            sm: "heading.large.mobile",
            xl: "heading.large.desktop",
          }}
          fontWeight="700"
          {...props}
        >
          {children}
        </ChakraHeadingWithMotion>
      )
    case "medium":
      return (
        <ChakraHeadingWithMotion
          lineHeight="heading"
          as="h2"
          fontSize="heading.medium"
          fontWeight="700"
          color={color}
          {...props}
        >
          {children}
        </ChakraHeadingWithMotion>
      )
    case "small":
      return (
        <ChakraHeadingWithMotion
          lineHeight="heading"
          as="h3"
          fontSize="heading.small"
          fontWeight="700"
          color={color}
          {...props}
        >
          {children}
        </ChakraHeadingWithMotion>
      )

    default:
      return (
        <ChakraHeadingWithMotion {...props}>{children}</ChakraHeadingWithMotion>
      )
  }
}
